<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="form">
    <form class="form" @submit.prevent="handleSubmit(onSubmit)">
      <div class="display-col">
        <span>Giảng viên<span style="color: red">*</span></span>
        <ValidationProvider class="w-100" vid="teacher_id" name="Giảng viên" rules="required" v-slot="{ errors,classes }">
          <el-select
              v-model="form.teacherId"
              filterable size="small"
              remote class="w-100"
              reserve-keyword
              placeholder="Tìm kiếm giảng viên"
              :remote-method="remoteMethod"
              :loading="loading">
            <el-option
                v-for="item in teacherOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                errors[0]
              }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="display-grid-cols-2">
        <div class="display-col">
          <span>Ngày<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="date" name="Ngày" rules="required" v-slot="{ errors,classes }">
            <el-date-picker
                v-model="form.date" class="w-100"
                type="date" size="small"
                placeholder="Chọn ngày"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
            >
            </el-date-picker>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="display-col">
          <span>Thời gian<span style="color: red">*</span></span>
          <ValidationProvider class="w-100" vid="time" name="Thời gian" rules="required" v-slot="{ errors,classes }">
            <el-time-picker
                v-model="form.time" class="w-100"
                is-range size="small"
                start-placeholder="Từ"
                end-placeholder="đến"
                value-format="HH:mm:ss"
            >
            </el-time-picker>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                  errors[0]
                }}
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div class="display-col">
        <span>Cơ sở dạy<span style="color: red">*</span></span>
        <ValidationProvider class="w-100" vid="centerId" name="Cơ sở dạy" rules="required" v-slot="{ errors,classes }">
          <el-select v-model="form.branchId" size="small" class="w-100" placeholder="Chọn cơ sở dạy">
            <el-option
                v-for="item in branches"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                errors[0]
              }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div class="display-col">
        <span>Đơn giá<span style="color: red">*</span></span>
        <ValidationProvider class="w-100" vid="price" name="Cơ sở dạy" rules="required" v-slot="{ errors,classes }">
          <el-input v-model="form.price" placeholder="Đơn giá" size="small"/>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{
                errors[0]
              }}
            </div>
          </div>
        </ValidationProvider>
      </div>
      <div style="display: flex; justify-content: end; gap: 2px; margin-top: 10px">
        <el-button type="info" @click="closeDialog">Hủy</el-button>
        <el-button native-type="submit" type="primary">Đồng ý</el-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
    CREATE_WORK_TIMESHEET,
    GET_SUBSTITUTE,
    UPDATE_WORK_TIMESHEET
} from "@/core/services/store/course/classes.module";

export default {
  name: 'WorkRecordForm',
  props: {
    branches: {
      type: Array,
      required: true,
      default: []
    },
    timeSheet: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      teacherOptions: [],
      loading: false,
      form: {
        teacherId: null,
        date: null,
        time: null,
        branchId: null,
        price: null,
      }
    }
  },
  mounted() {
    if (this.timeSheet) {
      this.form.teacherId = this.timeSheet.teacher_name
      this.form.date = this.timeSheet.date
      this.form.time = [this.timeSheet.start_time, this.timeSheet.end_time]
      this.form.branchId = this.timeSheet.branch
      this.form.price = this.timeSheet.unit_price
    }
  },
  methods: {
    onSubmit() {
      const basePayload = {
        teacher_id: typeof this.form.teacherId === 'number' ? this.form.teacherId : this.timeSheet.teacher_id,
        date: this.form.date,
        branch: typeof this.form.branchId === 'number' ? this.form.branchId : this.timeSheet.branch_id,
        unit_price: this.form.price,
        start_time: this.form.time[0],
        end_time: this.form.time[1]
      }
      const payload = {
        id: this.timeSheet?.id ?? 0,
        ...basePayload
      }
      this.$store.dispatch(this.timeSheet ? UPDATE_WORK_TIMESHEET : CREATE_WORK_TIMESHEET,this.timeSheet ? payload : basePayload).then((res) => {
        if (!res.error) {
          this.$message.success(this.timeSheet ? 'Cập nhật công ngày thành công !' : 'Thêm công ngày thành công !')
          this.$emit('createSuccess')
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.queryTeacher = query
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getTeacherSubstitute()
        }, 400);
      } else {
        this.teacherOptions = [];
      }
    },
    getTeacherSubstitute() {
      const payload = {
        teacher: this.queryTeacher
      }
      this.$store.dispatch(GET_SUBSTITUTE, payload).then((res) => {
        if (!res.error) {
          this.teacherOptions = res.data.map(item => {
            return {
              label: `${item.name} - ${item.id + 100000}`,
              value: item.id
            }
          })
        }
      }).catch((e) => {
        console.log(e, 'error')
      })
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
  .display-col {
    display: flex;
    flex-direction: column;
    gap: 6px;
      align-items: flex-start;
    width: 100%;
  }
  .display-grid-cols-2 {
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
</style>
